<template>
  <ais-state-results v-bind="$attrs">
    <template v-slot="{ state }">
      <div v-if="hasRefinments(state)">
        <span
          v-for="(refinement, i) of getRefinements(state)"
          :key="refinement"
          v-html="formatter(refinement, i, getRefinements(state))"
        />
      </div>
      <div v-else></div>
    </template>
  </ais-state-results>
</template>

<script>
export default {
  props: {
    attribute: {type: String, required: true},
    formatValue: {type: Function}
  },
  methods: {
    formatter(value, index, all) {
      const suffix = all.length > 1 && index < all.length - 1 ? ', ' : '';
      if (!this.formatValue) return value + suffix;
      return this.formatValue(value) + suffix;
    },
    hasRefinments(state) {
      const refinements = this.getRefinements(state);
      return refinements && refinements.length > 0;
    },
    getRefinements(state) {
      return state.facetsRefinements[this.attribute];
    }
  }
};
</script>
